<script setup lang="ts">

import MintCard from '@/partners/lingo/lingo-giveaway/components/MintCard.vue'
import useDetectOutsideClick from '@/composables/helpers/detect-outside-click'
import { ref } from 'vue'

defineProps<{
  entries: number
  prizeImage: string
  loading: boolean
}>()

const emit = defineEmits<{
  (e: 'hide'): void
}>()

const root = ref()
useDetectOutsideClick(root, () => {
  emit('hide')
})
</script>

<template>
  <div
    ref="root"
    class="flex flex-col gap-y-3 items-center"
  >
    <MintCard
      :entries="entries"
      :prize-image="prizeImage"
    />
  </div>
</template>